import React, { Component } from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import {withRouter} from "react-router-dom";

import TeachersTable from "./TeachersTable";

class TeachersList extends Component {

    render() {
        document.title ="Docenti | CLTV Cloud";

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <BreadCrumb title="Docenti" pageTitle="CLTV Cloud"/>
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        <TeachersTable />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(TeachersList);
